<template>
  <div class="fundsflow">
    <div>
      <van-nav-bar
        @click-left="navTo('/wallet')"
        fixed
        placeholder
        :title="$t('nav.fundsflow')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div style="margin-top: 20px;">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="no more"
        @load="onLoad"
      >
        <van-row v-for="(item, index) in list" :key="index">
          <van-col :style="{'color': item.billStatus == '2' ? '#E8001C' : '#00b520'}" span="6">
            {{ item.billStatus == '2' ? 'Fail' : 'Success' }}
          </van-col>
          <van-col style="color: #c58e5d" span="6">{{ item.nums }}</van-col>
          <van-col style="color: #999" span="6">{{ item.billId }}</van-col>
          <van-col style="color: #999" span="6">{{ item.createTime }}</van-col>
        </van-row>
      </van-list>
    </div>
  </div>
</template>

<script>
import { billList } from "@/common/api/api";

export default {
  name: "rechargeRecord",
  data() {
    return {
      active: "a",
      list: [],
      loading: false,
      finished: false,
      userId: "",
    };
  },
  created() {
    this.userId = this.$store.getters.userInfo.userId;
  },
  methods: {
    onLoad() {
      billList(this.userId, 1).then((res) => {
        this.list = res.data;
        this.finished = true;
      });
    },
    navTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style></style>
